import {useTranslation} from 'react-i18next';

interface Props {
    onNewQuestionnaire: () => void;
}

export default function ThankYou({onNewQuestionnaire}: Props) {
    const {t} = useTranslation();

    return (
        <div className="flex flex-col items-center gap-8 py-12 text-center">
            <img
                src="/freeda-logo.png"
                alt="Hey Freeda"
                className="h-32 w-32 object-contain"
            />

            <h2 className="text-3xl font-bold uppercase tracking-wide">
                {t('thankYou.title')}
            </h2>

            <div className="max-w-md space-y-4 text-gray-300">
                {t('thankYou.message')
                    .split('\n\n')
                    .map((paragraph, i) => (
                        <p key={i}>{paragraph}</p>
                    ))}
            </div>

            <a
                href="https://www.heyfreeda.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="min-h-[44px] rounded-lg bg-freeda-pink px-8 py-3 font-bold text-white transition-colors hover:bg-freeda-pink-dark focus:outline-none focus:ring-2 focus:ring-freeda-pink focus:ring-offset-2 focus:ring-offset-freeda-black"
            >
                {t('thankYou.learnMore')}
            </a>

            <button
                type="button"
                onClick={onNewQuestionnaire}
                className="min-h-[44px] rounded-lg border border-freeda-pink px-8 py-3 font-bold text-freeda-pink transition-colors hover:bg-freeda-pink hover:text-white focus:outline-none focus:ring-2 focus:ring-freeda-pink focus:ring-offset-2 focus:ring-offset-freeda-black"
            >
                {t('thankYou.newQuestionnaire')}
            </button>
        </div>
    );
}
